import styled from 'styled-components';
import { CircleTick } from 'assets/icons';
import { handleUnit } from 'lib/utils';

/**
 * Renders a <SimilarStockItems/> component
 * @param {Object} props
 * @param {Array} props.similarStockItems - Array items to be rendered
 * @param {String} props.currentStoreName - Current Store Name
 */

const SimilarStockItems = ({
  similarStockItems,
  currentStoreName,
  quantity,
  loadingPrices,
  vatExclusive,
  prices,
}) => {
  // TODO: add in pricing function once it is in master!
  const getPrice = (ve, p) => {
    let prodPrice;

    if (prices) {
      prodPrice = prices[p];
    }

    const {
      price,
      price_inclusive: priceInclusive,
      per_pack: perPack,
      unit,
    } = prodPrice;

    return prodPrice ? (
      <>
        <span className="fw-600 fs-18 ff-body">
          £{ve ? price.toFixed(2) : priceInclusive.toFixed(2)}
        </span>{' '}
        for {perPack}
        {handleUnit(unit) || ''}
      </>
    ) : null;
  };

  return (
    <div className="l-as-fs width-100">
      <p className="collection-products__title">Similar items in stock</p>
      <ul className="nm width-100">
        {similarStockItems.map(
          ({ id, description, image, partCode, stockCode, stock, slug }) => (
            <li
              className="fl collection-product"
              key={id}
              data-testid="similarstock-item">
              <div className="m-fl jc-c ai-c mb-10">
                <a href={`/catalogue/products/${slug}`}>
                  <img
                    src={image}
                    alt=""
                    width="64"
                    height="64"
                    className="collection-product__image"
                  />
                </a>
              </div>
              <div className="collection-product__content fw-w">
                <div className="collection-product__info">
                  <a
                    href={`/catalogue/products/${slug}`}
                    className="collection-product__title"
                    data-testid="similarstock-description">
                    {description}
                  </a>
                  <div className="collection-product__codes fl">
                    <div className="collection-code">
                      <span>Part Code:</span>
                      <strong> {partCode}</strong>
                    </div>
                    <div className="collection-code">
                      <span>Stock Code:</span>
                      <strong> {stockCode}</strong>
                    </div>
                  </div>
                </div>
                <div className="collection-product__stock-container m-fl jc-sb ai-c">
                  <div className="collection-product__stock m-fl">
                    {loadingPrices ? (
                      <div className="fl fb-50 collection-product__loading-container">
                        <div className="loader" />
                        <span>Loading Prices</span>
                      </div>
                    ) : (
                      <p
                        className="fs-13 fb-50 nm"
                        data-testid="similarstock-price">
                        {getPrice(vatExclusive, id)}
                      </p>
                    )}

                    <p className="fs-16 fl nm" data-testid="similarstock-stock">
                      <CircleTick
                        fillColorMain="#207600"
                        fillColorSecondary="#ffffff"
                        width="22px"
                        height="22px"
                      />
                      <StockSpan>{stock}</StockSpan> in stock
                    </p>
                  </div>
                  <a
                    href={`/basket/collections/new?product_id=${id}&address=${currentStoreName}&quantity=${quantity}`}
                    className="cef-btn cef-btn--green cef-btn--med">
                    Replace
                  </a>
                </div>
              </div>
            </li>
          ),
        )}
      </ul>
    </div>
  );
};

const StockSpan = styled.span`
  color: #207600;
  margin-left: 3px;
  margin-right: 3px;
  font-weight: 700;
`;

export default SimilarStockItems;
